import { useEffect } from "react";

import { Typography } from "@mui/material";
import { toast } from "react-toastify";

import { useWhiteScreen } from "../../../hooks/useWhiteScreen";
import { Container } from "../../common/Container/Container";
import { NotFound } from "../../common/NotFound/NotFound";
import { LeftMenu } from "./components/LeftMenu";
import { RightContent } from "./components/RightContent";
import {
	useMyCourseInstructor,
	useMyCourseInstructorInit,
} from "./hooks/useMyCourseInstructor";

import "./my_course_information.scss";

export function MyCourseInformation() {
	const { isSaving, loading } = useMyCourseInstructor();
	const { slug, isNotFound } = useMyCourseInstructorInit();

	useWhiteScreen();

	useEffect(() => {
		if (isSaving) {
			toast.loading(
				() => (
					<div>
						<Typography className="normal-text">Saving...</Typography>
						<Typography className="normal-text">
							Keep this window open
						</Typography>
					</div>
				),
				{
					toastId: "my-course-saving",
				},
			);
		} else {
			toast.dismiss("my-course-saving");
		}
	}, [isSaving]);

	if (!slug) {
		return null;
	}

	if (isNotFound) {
		return <NotFound white text="Service not found" />;
	}

	return (
		<Container
			navbarOrkaProps={{ white: true }}
			loading={loading}
			className="my-course-information-container">
			<div className="my-course-information-content-container">
				<LeftMenu />
				<RightContent />
			</div>
		</Container>
	);
}
